// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import { warehouseAddItem, WAREHOUSE_PRODUCT_ITEM,warehouseCentralCount,warehouseStateCount,warehouseTechnicianCount,warehouseTechnicianStateCount} from '../../actions/WarehouseActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/warehouse/WarehouseAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants,notificationConstants, commonConstants} from "../../constants";
import {getItem as productInfo} from '../../containers/product/ProductAddEditFormPage';
import {list as areaList} from '../../containers/area/AreaListPage';
import {list as userList} from '../../containers/user/ListPage';


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.warehouse.targetItem,
        userValue: state.app.currentUser,
        productInfo: state.product.getItem,
        areaList: state.area.areaList,
        userList: state.user.list,
        centralCount: state.warehouse.centralCount,
        stateCount: state.warehouse.stateCount,
        technicianCount: state.warehouse.technicianCount,
        technicianStateCount: state.warehouse.technicianStateCount,
    }
};

const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getAreaList: () => {
        return(dispatch(areaList()))
    },
    getUserList: (value) => {
        return(dispatch(userList(value)))
    },
    getProductInfo: (id) => {
        return(dispatch(productInfo(id)))
    },
    setProductId: (productId) => {
        return(dispatch({type: WAREHOUSE_PRODUCT_ITEM, data: productId}))
    },
    getCountProduct: (type,productId,stateId,technicianId) => {
        switch (type) {
            case 'central':
                return(dispatch(centralCount(productId)))
            break;
            case 'state':
                return(dispatch(stateCount(productId,stateId)))
            break;
            case 'technician':
                return(dispatch(technicianCount(productId,technicianId)))
            break;

        }
    },


    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    }

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values) => {

    return (dispatch, getState) => {
        const states = getState();
        let productId = '';

        if(states.warehouse.productWarehouse)
            productId = states.warehouse.productWarehouse

        else{
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'محصول وجود ندارد'
            })
        }

        let formData = {
            'product'     : productId,
            'count'       : parseInt(values.count),
            'row_type'    : values.row_type,
            'state'       : values.stateId,
            'technician'  : values.technicianId,
            'assign_type' : values.assign_type
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('warehouse', formData).then(res => {
            dispatch(warehouseAddItem(res.data));
            if(res.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/product/list'}), 100)
            }
            else if(res.data.system_error_code === 702) {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: notificationConstants.ERROR,
                    message: 'مقدار درخواستی از موجودی انبار بیشتر میباشد.'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const centralCount = (productId) => {

    return (dispatch, getState) => {

        let formData = {
            'type': 'central',
            'productId': productId,
        };
        API_FETCH.get('warehouse/inventory', {params: formData}).then(res => {
            dispatch(warehouseCentralCount(res.data.total_count));
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const stateCount = (productId,stateId) => {

    return (dispatch, getState) => {

        let formData = {
                'type'      : 'state',
                'productId' : productId,
                'state'     : stateId,
            };

        API_FETCH.get('warehouse/inventory', {params: formData}).then(res => {
            dispatch(warehouseStateCount(res.data.total_count));
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const technicianCount = (productId,technicianId) => {

    return (dispatch, getState) => {
        let formData = {
                'type'      : 'technician',
                'productId' : productId,
                'technician': technicianId,
            };

        API_FETCH.get('warehouse/inventory', {params: formData}).then(res => {
            dispatch(warehouseTechnicianCount(res.data));
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
